// extracted by mini-css-extract-plugin
export var lg = "_2y-4";
export var md = "_2y-3";
export var sm = "_2y-2";
export var xs = "_2y-1";
export var xxs = "_2y-0";